import { Unsubscribe } from 'firebase/firestore';
import { useEffect, useRef, useState } from 'react';

import { checkLastMessageSeenStatus, listenToSeenStatus } from '@/slw/shared/lib/firebase/utils';

export function useMessageSeenStatus(chatId: string | null, messageId: string, currentUserId: string) {
  const [seenStatus, setSeenStatus] = useState<{
    isMyLastMessage?: boolean;
    isSeen?: boolean;
    loading: boolean;
    error?: null | string;
  }>({
    isMyLastMessage: false,
    isSeen: false,
    loading: true,
    error: null,
  });

  const unsubscribeRef = useRef<Unsubscribe | null>(null);

  useEffect(() => {
    if (!chatId || !currentUserId) return;

    // Initial check
    checkLastMessageSeenStatus(chatId, messageId, currentUserId).then((result) => {
      if (result.success) {
        setSeenStatus({
          isMyLastMessage: result.isMyLastMessage,
          isSeen: result.isSeen,
          loading: false,
          error: null,
        });
      } else {
        setSeenStatus((prev) => ({
          ...prev,
          loading: false,
          error: result.error || result.message,
        }));
      }
    });

    // Setup real-time listener
    listenToSeenStatus(chatId, currentUserId, (result) => {
      if (result.success) {
        setSeenStatus((prev) => ({
          ...prev,
          isSeen: result.isSeen,
          loading: false,
          error: null,
        }));
      } else {
        setSeenStatus((prev) => ({
          ...prev,
          loading: false,
          error: result.error || result.message,
        }));
      }
    }).then((unsubscribe: Unsubscribe) => {
      unsubscribeRef.current = unsubscribe;
    });

    return () => {
      if (unsubscribeRef.current) {
        unsubscribeRef.current();
      }
    };
  }, [chatId, currentUserId, messageId]);

  return seenStatus;
}
